import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { Planbook } from "@shared/models/planbook"
import { handleError } from "cc-frontend/error-handling"
import type PatchCoordinator from "cc-frontend/services/patch-coordinator"
import type Rpc from "cc-frontend/services/rpc"

export interface MigratingToUnifiedLessonsModalArgs {
  planbook: Planbook
}

interface Signature {
  Args: {
    model: MigratingToUnifiedLessonsModalArgs
  }
}

export default class MigratingToUnifiedLessonsModal extends Component<Signature["Args"]> {
  @service declare rpc: Rpc
  @service declare patchCoordinator: PatchCoordinator

  @action
  startMigration() {
    // Disable patch applications to prevent spurious errors during the migration.
    // We'll refresh at the end so that you don't miss any changes
    // (including in error cases, via handleError).
    this.patchCoordinator.setIsReceiving(false)

    this.rpc
      .planbook_migrate({
        planbookId: this.args.model.planbook.id,
        migration: "unifiedLessons",
      })
      .then((response) => {
        if (response.responseOk) {
          window.location.reload()
        } else {
          handleError(new Error("Planbook migration responded with " + response))
        }
      })
      .catch(handleError)
  }
}
